import React from "react"
import { graphql } from "gatsby"
import MainPage from "./MainPage"
import { IBlogPost } from "@organic-return/foundation-react/src/lib/BlogPost"
import { PostLayoutSearchColumn } from "@organic-return/foundation-react/src/components/BlogPost/PostLayoutSearchColumn"
import { useSiteContext } from "../components/common/SiteContext"
import { ESocialChannel, ISocialLink } from "@organic-return/foundation-react/src/lib/Contact/types"

export const query = graphql`
  query($nodeID: String!) {
    drupalPost(id: { eq: $nodeID }) {
        id        
        title
        content
        date
        image {
          url
        }
        author        
        categories {        
          title        
        }
        tags {          
          title          
        }
        path  
        agents {
          fullName
          first
          last
          path
        }
        postButtons {
          url {
            url
            title
          }
        }
        metaDescription
        metaKeywords
        sEOTitle
        sEODescription
    }
    allDrupalPostTag(sort:{title:ASC}) {
        distinct(field:{ title: SELECT })
    }
    allDrupalCategory(sort:{title:ASC}) {
        distinct(field:{ title: SELECT })
    }
    latestPosts: allDrupalPost(sort:{date:DESC}, limit: 5) {
	  nodes {		    
        title
        path
      }
    }
    config: drupalSiteConfiguration {
      siteName
      blogPostSearchPath
      blogPostLayoutTitle
      socialLinks {
        facebook {
          url
          title
        }
        instagram {
          url
          title
        }
        linkedIn {
          url
          title
        }
        twitter {
          url
          title
        }
        youTube {
          url
          title
        }
        vimeo {
          url
          title
        }
        pinterest {
          url
          title
        }
      }  
    }    
  }
`

const BlogPostPage = ({ pageContext, data, location }: any) => {
  const siteContext = useSiteContext();

  const blogPost = data.drupalPost;

  const postModel: IBlogPost = {
    title: blogPost.title,
    content: blogPost.content,
    date: blogPost.date && new Date(blogPost.date),
    image: blogPost.image?.url && { url: blogPost.image.url },
    author: blogPost.author,
    path: blogPost.path,
    categories: blogPost.categories?.[0] && blogPost.categories.map((c: any) => { return c.title }),
    tags: blogPost.tags?.[0] && blogPost.tags.map((t: any) => { return t.title }),
    agents: blogPost.agents,
    buttons: blogPost.postButtons?.[0] && blogPost.postButtons.map((b: any) => { return {href: b.url.url, text: b.url.title, target:"_blank"} }),
  }

  let recentPosts: any = undefined;
  if (data.latestPosts.nodes?.[0]) {
    recentPosts = data.latestPosts.nodes.map((p: any) => {
      return {
        href: p.path ?? "",
        text: p.title ?? ""
      }
    })
  }

  const pageSocials = data.config.socialLinks
  let socials: ISocialLink[] = []
  pageSocials?.facebook &&
    socials.push({
      channel: ESocialChannel.Facebook,
      text:
        pageSocials.facebook.title ||
        data.config.siteName + " on Facebook",
      url: pageSocials.facebook.url,
    })
  pageSocials?.instagram &&
    socials.push({
      channel: ESocialChannel.Instagram,
      text:
        pageSocials.instagram.title ||
        data.config.siteName + " on Instagram",
      url: pageSocials.instagram.url,
    })
  pageSocials?.twitter &&
    socials.push({
      channel: ESocialChannel.Twitter,
      text:
        pageSocials.twitter.title ||
        data.config.siteName + " on Twitter",
      url: pageSocials.twitter.url,
    })
  pageSocials?.youTube &&
    socials.push({
      channel: ESocialChannel.YouTube,
      text:
        pageSocials.youTube.title ||
        data.config.siteName + " on YouTube",
      url: pageSocials.youTube.url,
    })
  pageSocials?.vimeo &&
    socials.push({
      channel: ESocialChannel.Vimeo,
      text:
        pageSocials.vimeo.title ||
        data.config.siteName + " on Vimeo",
      url: pageSocials.vimeo.url,
    })
  pageSocials?.pinterest &&
    socials.push({
      channel: ESocialChannel.Pinterest,
      text:
        pageSocials.pinterest.title ||
        data.config.siteName + " on Pinterest",
      url: pageSocials.pinterest.url,
    })
  pageSocials?.linkedIn &&
    socials.push({
      channel: ESocialChannel.LinkedIn,
      text:
        pageSocials.linkedIn.title ||
        data.config.siteName + " on LinkedIn",
      url: pageSocials.linkedIn.url,
    })

  var pageTitle = blogPost.sEOTitle;
  var pageDescripton = blogPost.sEODescription;
  var pageKeywords = data.drupalPost.metaKeywords ?? (postModel.tags?.join(", ") || postModel.categories?.join(", "));
  return (
    <MainPage
      seoProps={{
        title: `${pageTitle}`,
        keywords: pageKeywords,
        description: pageDescripton,
        location: location,
      }}
      headerProps={{ gradient: false, ...siteContext.headerProps }}
      className="blog-post-page"
    >
      <PostLayoutSearchColumn
        colsWrapperClassName="max-w-screen-xl mt-10"
        post={postModel}
        allTags={data.allDrupalPostTag.distinct}
        allCategories={data.allDrupalCategory.distinct}
        recentPosts={recentPosts}
        postSearchBasePath={data.config?.blogPostSearchPath}
        title={data.config?.blogPostLayoutTitle}
        titleWrapperClassName="inverted"
        tileClassName="block mx-auto max-w-screen-xl text-left"
        socialMediaLinks={socials}
        {...siteContext.blogPostPageLayoutProps}
      />
    </MainPage>
  )
}

export default BlogPostPage